//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import { openURL } from 'quasar'
import { get } from 'vuex-pathify'
import store from '../store/index'

export default {
  data () {
    return {
      init: false,
      submit_btn_disable: true,
      loading: false,
      query:"1",
      total_record: 0,
      total_page: 1,
      rowsPerFetch: 100,
      pagination: {
        rowsPerPage: 0
      },
      pageID: 1,
      model: {label: "", value: ""},
      roundList: [],
      roundOptions:this.roundList,
      round_selected: {label: "", value: "" },
      data_key: 'rownum',
      dense: false,
      datalist: [],
      selected: [],
      columns: [
        { name: 'rownum', align: 'center', label: 'ลำดับ', field: 'rownum'},
        { name: 'round', align: 'center', label: 'รอบ', field: 'round'},
        { name: 'doc_no', align: 'center', label: 'เลขที่ใบหัก ณ ที่จ่าย', field: 'doc_no'},
        { name: 'mcode', align: 'center', label: 'รหัสสมาชิก', field: 'mcode'},
        /*{ name: 'name_f', align: 'left', label: 'คำนำหน้าชื่อ', field: 'name_f' },*/
        { name: 'name_t', align: 'left', label: 'ชื่อสมาชิก', field: 'name_t' },
        { name: 'bonusda', align: 'right', label: 'โบนัสรายวัน', field: 'bonusda' },
        { name: 'bonusmo', align: 'right', label: 'โบนัสรายเดือน', field: 'bonusmo'},
        { name: 'total_bonus', align: 'right', label: 'รวมโบนัส', field: 'total_bonus'},
        { name: 'wh_tax', align: 'right', label: 'หักภาษี ณ ที่จ่าย', field: 'wh_tax'}
      ],
    }
  },
  methods: {
      refresh (done) {
        setTimeout(() => {
          this.getData();
          done();
        }, 1000)
      },
      setRoundmoSelected() {
        this.round_selected = this.roundList[0];
      },
      /* 
      exportPDF: function(round, descript) {
          let self = this;
          openURL(self.url_api + '../pdf/Report.Month.Bonus.Detail.ByMcode.PDF.aspx?round=' + round + '&des='+ descript);    
      },
      */
      exportPDF: function(round, seq) {
          let self = this;
          let actionUrl = self.url_api + "../pdf/WithHoldingTaxForm.PDF.aspx";
          let windowName = "";
          let windowFeatures = "";
          let data = {
                        Authorization: self.jwt_token,
                        round: round,
                        seq: seq
                     };
          this.windowOpenWithPost(actionUrl, windowName, windowFeatures, data);
      },

      requestRowClick: function(selected_mcode, selected_row) {
          if (this.selected.mcode !== selected_mcode) {
            this.selected.splice(0,1);
            this.selected.push(selected_row);
          }
      },
      fetchRoundTax: function () {
        let self = this;
        self.axios({
          method: "post",
          headers: {
            'Authorization': self.jwt_token
          },
          url: self.url_api + "MemberClient/RoundTaxYear.ListAll.JSON.aspx"
        })
        .then(function (response) {
          let responseDoc = new DOMParser().parseFromString(response.data, 'text/xml');
          //let round = responseDoc.getElementsByTagName('round_selected')[0].textContent;
          self.roundList = JSON.parse(responseDoc.getElementsByTagName('json')[0].textContent);
          /*
          console.log("result round selected -> :" + round);
          console.log("json roundList:" + responseDoc.getElementsByTagName('json')[0].textContent);
          */
          //self.setRoundmoSelected(round);
          self.setRoundmoSelected();
        })
        .catch(function (error) {
          console.log("Roundmo List Error :" + error);
        });
      },
      filterFnAutoselect (val, update) {
        // call abort() at any time if you can't retrieve data somehow
        setTimeout(() => {
          update(
            () => {
             if (val === '') {
                this.roundOptions = this.roundList
              }
              else {
                const needle = val.toLowerCase()
                this.roundOptions = this.roundList.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
                //console.log("filter result:" + this.roundOptions[0].label);
                /*
                const result = members.filter((jsonOptions) => {
                  return jsonOptions.label > 25
                })
                this.options = result*/
              }
            },
            // next function is available in Quasar v1.7.4+;
            // "ref" is the Vue reference to the QSelect
            ref => {
              if (val !== '' && ref.options.length > 0 && ref.optionIndex === -1) {
                ref.moveOptionSelection(1, true) // focus the first selectable option and do not update the input-value
                ref.toggleOption(ref.options[ref.optionIndex], true) // toggle the focused option
              }
            }
          )
        }, 300)
      },
      abortFilterFn () {
        // console.log('delayed filter aborted')
      },
      getData: function () {
        var self = this;
        self.loading = true;
        self.rowsPerFetch = self.appRowsPerFetch;
        
        const params = new URLSearchParams();
        params.append('mcode', self.session_mcode)
        params.append('round', self.round_selected.value);

        self.axios({
          method: 'post',
          headers: {
            'Authorization': self.jwt_token
          },
          timeout: 0,
          url: self.url_api + 'MemberClient/GetWHTYear.JSON.aspx',
          data: params
        })
        .then(function (response) {
            let responseDoc = new DOMParser().parseFromString(response.data, 'text/xml');
            let record_count = parseInt(responseDoc.getElementsByTagName('recordcount')[0].textContent);
            let page_count = 1;
            //let page_count = parseInt(responseDoc.getElementsByTagName('pagecount')[0].textContent);
            if (record_count > 0) {
              self.datalist = JSON.parse(responseDoc.getElementsByTagName('json')[0].textContent);
              self.selected = JSON.parse(responseDoc.getElementsByTagName('json')[0].textContent).slice(0, 1);
            } else {
              self.datalist = [];
              self.selected = [];
            }
            self.total_record = record_count;
            self.total_page = page_count;
            self.loading = false;
            self.init = true;
            self.$q.loading.hide();
        })
        .catch(function (error) {
            //console.log("Error :" + error + ' round : ' + self.selected.value);
            console.log("Error :" + error);
            self.datalist = [];
            self.selected = [];
            self.loading = false;
            self.$q.loading.hide();
        });
      }
  },
  mounted: function () {
      this.fetchRoundTax();
      //console.log('Component mounted.');
      //this.getData();
  },
  computed: {
      url_api: get('URL_API_PATH'),
      jwt_token: get('JWT_TOKEN'),
      mcode_length: get('APP_MCODE_LENGTH'),
      appRowsPerFetch: get('APP_ROW_PER_FETCH'),
      session_mcode: get('SESSION_MCODE_LOGIN')
  },
  watch: {
    pageID: function () {
      if (this.init) {
        this.getData();
      }
    },
    round_selected: function () {
      this.getData();
      /*
      if (this.init) {
        this.getData();
      }
      */
    }
  },
  created () {
      //console.log('Component created.');
      store.set("APP_TOOLBAR_TITLE","ใบหักภาษี ณ ที่จ่าย รหัส : " + this.session_mcode);
      this.$q.loading.show();
  }    
}   
